import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { PageLayout } from "./components/PageLayout";
import { WelcomePage  } from "./components/WelcomePage";
import { ReportList } from "./components/ReportList";
import { createBrowserRouter, createRoutesFromElements, Route, Outlet, RouterProvider } from "react-router-dom";
import { ReportNew } from "./components/ReportNew";

export default function App() {

    const router = createBrowserRouter(
        createRoutesFromElements(
            <Route path="/" element={<Root />} >
                <Route index element={<ReportList />} />
                <Route path="/projects/reports" element={<ReportList />} />
                <Route path="/projects/new" element={<ReportNew />} />
            </Route>
        )
    )
    return (
        <div>
            <RouterProvider router={router}/>
        </div>
    );
}

const Root = () => {
    return <>
        <PageLayout>
            <AuthenticatedTemplate>
                <Outlet />
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <WelcomePage />
            </UnauthenticatedTemplate>
        </PageLayout>
    </>
}
